import React from 'react';
import { useTranslation } from 'react-i18next';
import { components } from 'src/generated/v1';
import Modal from '../../layouts/Modal/Modal';

export type ConnectorFeedError = components['schemas']['ConnectorFeedError'];

export type ConnectorErrorModalProps = {
  error: ConnectorFeedError | null;
  onClose: () => void;
  formatDate: (input: string) => string;
};

const ConnectorErrorModal: React.FC<ConnectorErrorModalProps> = ({ error, onClose, formatDate }) => {
  const { t } = useTranslation();

  if (!error) {
    return null;
  }

  return (
    <Modal isOpen onClose={onClose} hasDefaultPadding>
      <div className="max-w-[560px] w-[80vw] flex flex-col gap-[16px]">
        <h4 className="typo-title-20 pr-24 break-words">{error.name}</h4>
        <div className="flex flex-col gap-[4px]">
          <span className="typo-text-12 text-faded">
            {t('general.date')}: {formatDate(error.created_at)}
          </span>
          {error.type && (
            <span className="typo-text-12 text-faded">
              {t('integrations.error_type')}: {t(`integrations.feed_type_${error.type}`, error.type)}
            </span>
          )}
        </div>
        <p className="typo-text-14 whitespace-pre-wrap break-words max-h-[50vh] overflow-y-auto">
          {error.message || t('general.no_data')}
        </p>
      </div>
    </Modal>
  );
};

export default ConnectorErrorModal;
